<div class="flex column ">
  <div [style.height]="height" class="flex column upload-container" aoDragFileUpload (files)="filesDropped($event)"
    (click)="uploadFileClick()">
    <div *ngIf="!fileImage.url" class="flex column">
      <div class="">تصویر موردنظر را اینجا بکشید</div>
    </div>
    <div *ngIf="fileImage.url" class="column flex">
      <img width="100%" [style.height]="height" [src]="fileImage.url" alt="">
    </div>
    <input #file [style.display]="'none'" accept="image/*" (change)="onFilesAdded($event)" type="file">
  </div>
</div>
